import StickySidebar from 'sticky-sidebar-v2';

export default () => {
    if (!document.querySelector('.support__sidebar')) {
        return;
    }

    let sidebar;

    function handleResize(query) {
        if (query.matches) {
            if (sidebar && typeof sidebar.destroy !== undefined) {
                sidebar.destroy();
            }
        } else {
            sidebar = new StickySidebar('.support__sidebar', {
                topSpacing: document.querySelector('.header').offsetHeight + 20,
                bottomSpacing: 0,
                containerSelector: '.support__columns',
                innerWrapperSelector: '.support__sidebar-inner',
            });
        }
    }

    const query = window.matchMedia('(max-width: 768px)');
    handleResize(query);
    query.addListener(handleResize);
};
